import React from "react";
 import comingIcon from "../images/comingSoon.png"
const ComingSoon=()=>{
    return(
        <img src={comingIcon} style={{width:"566px", height:"566px", position:"absolute", top:"175px", left:"600px"}}/>

    )
}
export default ComingSoon